import React from "react";
import { connect } from "react-redux";
import QuoteStepBase from '../components/QuoteStepBase';
import { IQuoteStepComponentProps } from "../components/interfaces";
import QuoteStep from "./QuoteStepLayout";
import { IAgenciesContactInfo, IQuoteApiClient } from "../classes/Domain";
import { IAppState } from "../state/interfaces";
import QuoteActions from "../state/appActions";
import { QUOTE_STEPS } from "../AppConstants";
import Utilities from "../classes/Utilities";


interface IAgenciesProps extends IQuoteStepComponentProps {
    agenciesContactInfo: IAgenciesContactInfo | null,
    quoteApiClient: IQuoteApiClient
}

class Agencies extends QuoteStepBase<IAgenciesProps, any> {
    constructor(props: IAgenciesProps) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStep id="agencies" className="rate-result">
                <div className="titleArea"><h5>AGENCIES</h5></div>
                {
                    this.props.agenciesContactInfo?.agencyContacts && 0 < this.props.agenciesContactInfo.agencyContacts.length
                        ?
                        this.props.agenciesContactInfo.agencyContacts.map((agency) => (
                            <div className="payment-choice accident" key={Utilities.uniqueId()}>
                                <div className="term">
                                    <div className="term-name">{agency.agencyName}</div>
                                </div>
                                <div className="item">
                                    <label className="left-cell"><strong>Tel.:</strong></label>
                                    <label className="right-cell">{agency.agencyPhone}</label>
                                </div>
                                <div className="item no-border">
                                    <label className="left-cell"><strong>Address</strong></label>
                                    <label className="right-cell">{agency.agencyStreetAddress}</label>
                                </div>
                                {
                                    agency.agencyWebsiteURL && agency.agencyWebsiteURL.length > 0
                                        ?
                                        <div className="item no-border">
                                            <label className="left-cell"><strong>Website</strong></label>
                                            <label className="right-cell">{agency.agencyWebsiteURL}</label>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        ))
                        :
                        <div className="choice no-border">
                            <p className="text-center w-100">
                                To finish with an agent please call us.
                                </p>
                            <div className="text-center">
                                <a href={"tel:" + this.props.agenciesContactInfo?.callCenterPhone} className="btnContinue btn btn-primary btn-sm for-mobile">Call Us <i className="fas fa-phone"></i></a>
                                <span className="big-label text-center for-desktop">{this.props.agenciesContactInfo?.callCenterPhone}</span>
                            </div>
                        </div>
                }
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        agenciesContactInfo: state.agenciesContactInfo,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IAgenciesProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.COVERAGES))
    };
};

export default connect(mapProps, mapDispatch)(Agencies);